"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
var api_1 = require("./api");
var fetch_1 = require("./fetch");
var BaseService = /** @class */ (function () {
    function BaseService(config, logger) {
        this.config = config;
        this.fetch = (0, fetch_1.fetch)({ logLevel: config.logLevel });
        this.logger = logger !== null && logger !== void 0 ? logger : (0, fetch_1.getLogger)(config);
    }
    BaseService.prototype.getAPIUrl = function (_a) {
        var context = _a.context, pathname = _a.pathname, query = _a.query, service = _a.service;
        return (0, api_1.getAPIUrl)({
            service: service !== null && service !== void 0 ? service : this.config.api,
            context: context,
            pathname: pathname,
            query: query,
            parallelTest: this.config.parallelTest,
            testingPortMappings: this.config.uiPortToAPIPort
        });
    };
    return BaseService;
}());
exports.BaseService = BaseService;
